import { render, staticRenderFns } from "./UrbanTransit.vue?vue&type=template&id=1510a354&scoped=true&"
import script from "./UrbanTransit.vue?vue&type=script&lang=js&"
export * from "./UrbanTransit.vue?vue&type=script&lang=js&"
import style1 from "./UrbanTransit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1510a354",
  null
  
)

export default component.exports